import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

export default function NotFoundPage(): JSX.Element {
  return (
    <>
      <Helmet>
        <title>Not found — Padstow Insider</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <main
        id="main"
        className="container-narrow safe-top safe-bottom flex min-h-dvh flex-col items-center justify-center text-center"
      >
        <h1 className="font-display text-4xl text-moor-800">Lost the path</h1>
        <p className="mt-3 text-slate-700">That page isn't here.</p>
        <Link to="/" className="btn-primary mt-6">
          Take me home
        </Link>
      </main>
    </>
  );
}
